import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04e3034c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "material-icons-round"
}
const _hoisted_2 = {
  key: 1,
  class: "material-icons-round"
}



export default /*#__PURE__*/_defineComponent({
  props: {
    open: {
        type: Boolean, 
        required: true
    }
},
  setup(__props) {

const props = __props



return (_ctx: any,_cache: any) => {
  return (props.open)
    ? (_openBlock(), _createElementBlock("i", _hoisted_1, "close"))
    : (_openBlock(), _createElementBlock("i", _hoisted_2, "add"))
}
}

})